<template>
  <v-container>
    <v-row class="mb-2">
      <v-col>
        <h1>Language Translator</h1>
      </v-col>
    </v-row>
    <v-form ref="form" :lazy-validation="true">
      <v-row class="justify-center">
        <v-col cols="12" md="6">
          <v-textarea
            color="red"
            outlined
            label="Enter Text"
            v-model="fromText"
            :rules="fromTextRules"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col cols="12" md="4" sm="12">
          <v-select
            color="red"
            :items="languageOptions"
            label="From Language"
            outlined
            v-model="fromLanguage"
            :rules="fromLanguageRules"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" sm="12">
          <v-select
            color="red"
            :items="languageOptions"
            label="To Language"
            outlined
            v-model="toLanguage"
            :rules="toLanguageRules"
          ></v-select>
        </v-col>
        <v-col class="text-center" cols="12" md="1" sm="12">
          <v-btn x-large color="red" dark @click.prevent="translate">
            Translate
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col cols="12" md="6">
          <v-textarea
            color="red"
            outlined
            label="Translation"
            v-model="toText"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { Predictions } from "aws-amplify";
export default {
  data() {
    return {
      fromLanguage: "",
      fromLanguageRules: [v => !!v || "From language is required"],
      toLanguage: "",
      toLanguageRules: [v => !!v || "To language is required"],
      fromText: "",
      fromTextRules: [v => !!v || "From text is required"],
      toText: "",

      languageOptions: [
        { value: "", text: "Please select a language" },
        { value: "ar", text: "Arabic" },
        { value: "cs", text: "Czech" },
        { value: "zh", text: "Chinese" },
        { value: "en", text: "English" },
        { value: "fr", text: "French" },
        { value: "de", text: "German" },
        { value: "it", text: "Italian" },
        { value: "ja", text: "Japanese" },
        { value: "pt", text: "Portuguese" },
        { value: "ru", text: "Russian" },
        { value: "es", text: "Spanish" },
        { value: "tr", text: "Turkish" }
      ]
    };
  },
  methods: {
    async translate() {
      const valid = this.$refs.form.validate();
      if (!valid) return;

      let translation = await Predictions.convert({
        translateText: {
          source: {
            text: this.fromText,
            language: this.fromLanguage
          },
          targetLanguage: this.toLanguage
        }
      });
      this.toText = translation.text;
    }
  }
};
</script>
